import { createSlice } from '@reduxjs/toolkit'
import { centersTexts } from 'locale/es'
import CentersService from 'services/CentersService'
import { toast } from './notificationReducer'
import { selectCenter, updateSelectedCenter } from './selectedCenterReducer'
import { appendUserCenter, removeUserCenter, updateUserCenter } from './userAuthenticationReducer'

const centerSlice = createSlice({
  name: 'centers',
  initialState: { data: null, loading: false, error: null },
  reducers: {
    setCenter(state, action) {
      const { data } = action.payload

      return { ...state, data, loading: false, error: null }
    },
    appendCenter(state, action) {
      const { data } = action.payload

      return { ...state, data: [...state.data, data], loading: false, error: null }
    },
    updateCenter(state, action) {
      const { data } = action.payload

      const updatedCenters = state.data.map((center) =>
        center.id !== data.id ? center : data
      )

      return { ...state, data: updatedCenters, loading: false, error: null }
    },
    deleteCenter(state, action) {
      const newDataState = state.data.filter((center) => center.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null }
    },
    setCentersLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setCentersError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
})

export const { setCenter, appendCenter, updateCenter, deleteCenter, appendComment, setCentersLoading, setCentersError } =
  centerSlice.actions

export const initializeCenters = () => {
  return async (dispatch, getState) => {
    try {
      const centers = getState().centers.data

      if (!centers) {
        dispatch(setCentersLoading());

        const { data } = await CentersService.getCenters()
        dispatch(setCenter({ data }))
      }
    }
    catch (error) {
      console.error(error)
      dispatch(setCentersError({ message: error.message, status: error.response?.status }));
      dispatch(toast(centersTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const createCenter = (centerObj) => {
  return async (dispatch) => {
    try {
      const { data } = await CentersService.create(centerObj)
      dispatch(appendCenter({ data }))
      dispatch(appendUserCenter(data))

      dispatch(toast(centersTexts.CREATED, 'success'))
    } catch (error) {
      dispatch(setCentersError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const updateCenterAction = (centerObj) => {
  return async (dispatch, getState) => {
    try {
      const userCenters = getState()?.userAuthentication?.user?.centers
      const isUpdatingUserCenter = userCenters.some(center => center.id === centerObj.id)

      const selectedCenter = getState()?.center?.data
      const isSelectedCenter = selectedCenter.id === centerObj.id

      const { data } = await CentersService.update(centerObj.id, centerObj)
      dispatch(updateCenter({ data }))

      if (isUpdatingUserCenter) {
        dispatch(updateUserCenter({ data }))
      }

      if (isSelectedCenter) {
        dispatch(updateSelectedCenter(data))
      }

      // dispatch(selectCenter(data))
      dispatch(toast(centersTexts.EDITED, 'success'))
      return data;
    } catch (error) {
      console.error(error)
      dispatch(setCentersError({ message: error.message, status: error.response?.status }));
      dispatch(toast(centersTexts.EDITED_ERROR, 'error'))
    }
  }
}

export const duplicateCenter = (centerObj) => {
  return async (dispatch) => {
    try {
      // const { data } = await CentersService.create(centerObj) // TODO: Change to duplicate call
      // dispatch(appendCenter({ data }))
      dispatch(toast(centersTexts.CREATED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setCentersError({ message: error.message, status: error.response?.status }));
      dispatch(toast(centersTexts.CREATION_ERROR, 'error'))
    }
  }
}

export const deleteCenterAction = (id) => {
  return async (dispatch, getState) => {
    try {
      const userCenters = getState()?.userAuthentication?.user?.centers
      const isDeletingUserCenter = userCenters.some(center => center.id === id)

      const selectedCenter = getState()?.center?.data
      const isSelectedCenter = selectedCenter.id === id

      await CentersService.remove(id)

      dispatch(deleteCenter(id))

      if (isDeletingUserCenter) {
        dispatch(removeUserCenter(id))
      }

      const updatedUserCenters = getState()?.userAuthentication?.user?.centers
      if (isSelectedCenter && updatedUserCenters.length > 0) {
        dispatch(selectCenter(updatedUserCenters[0]))
      }

      dispatch(toast(centersTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setCentersError({ message: error.message, status: error.response?.status }));
      dispatch(toast(centersTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default centerSlice.reducer